module.exports = __webpack_public_path__ + "static/media/share.f2efa8ae.svg";